export default "__VITE_ASSET__GkjR5MlJ__"